module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_vestland_neg.0ef66995.pdf";